
import React from 'react';
import SurgirButton from '../../components/ui/SurgirButton/SurgirButton';
import './Home.scss';
import {  Col, Container, Row} from 'react-bootstrap';
import Porki from "../../assets/images/benefits/security-verified.svg";
import HandMoney from "../../assets/images/benefits/benefits-cuota-credito.svg";
import TwoHands from "../../assets/images/benefits/hands-red.svg";
import Clock from "../../assets/images/benefits/flexible.svg";
import bannerHome from '../../assets/images/home/Banner home_2.png'
import PromocionesHome from '../../assets/images/home/auto-home-desktop.png'
import SurgirPrincipalTitle from 'components/ui/SurgirPrincipalTitle/SurgirPrincipalTitle';
import CoberturaFallecimiento from '../../assets/images/home/Home nosotros.png';
import SurgirItemCard from 'components/ui/SurgirItemCard/SurgirItemCard';
const Home: React.FC = () => {



  const redirectContactanos = () => {
    window.location.href = '/canaldigital'
  }
  const redirectAuto = () => {
    window.location.href = '/canaldigital'
  }
  const redirectAboutUs = () => {
    window.location.href = '/quienes-somos'
  }


  return (
    <div>

         <div className="boxi-home"  style={{ backgroundColor: ' #ffffff ' }}>
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner"> Alcancemos juntos el <span style={{color:"#EC0000"}}>auto que tanto deseas </span><br />
                <span className="banner-subText-banner">Te guiamos para hacerlo realidad.</span>
              </span>
              <SurgirButton
                  onClick={redirectAuto}
                  radius={'32px'}
                  fontFamily={"SantanderTextW05-Bold"}
                  width='230px'
                  height='40px'
                  marginTop="30px"
                  variant="danger"
                >
Cotiza tu auto aquí                 </SurgirButton>
            </div>
            <div>
              <img className="banner-image" src={bannerHome} alt="Página Principal Santander Fondos Colectivos" />
            </div>

          </div>
        </Container>

      </div>
      <div style={{ backgroundColor: '#F6FAFC ' }}>
        <div className='home-aboutUS' >
          <div   >
            <img className='home-aboutUS-img' style={{ borderRadius: "16px" }} src={CoberturaFallecimiento} alt="Seguro Desgravamen" />
           
          </div> <br/>
          <div style={{paddingLeft:10}}>
           
            <p className="subtitle_form" >
             <span style={{color:"#EC0000"}}> Sobre Nosotros</span>
            </p>

            <div > 
              <div className='home-aboutUS-text'>
                <span  className="parrafo">Fondos Colectivos del Grupo Santander nace como una iniciativa de poder ayudar a personas como tú, a adquirir un vehículo de manera fácil, rápida, y más económica que los préstamos convencionales.
                  Buscamos que más personas puedan adquirir el vehículo de sus sueños. ¡Súmate y se parte de nosotros!
                  Si quieres saber más de acerca de quienes componen nuestro equipo, visítanos en la sección quienes somos.
                </span>
              </div>
              <div>
                <SurgirButton
                  onClick={redirectAboutUs}
                  radius={'32px'}
                  fontFamily={"SantanderTextW05-Bold"}
                  width='180px'
                  height='40px'
                  marginTop="20px"
                  variant="danger"
                >
                  Más sobre nosotros
                </SurgirButton>
              </div>
              <div   >
            <img className='home-aboutUS-mobile' style={{ borderRadius: "16px" }} src={CoberturaFallecimiento} alt="Seguro Desgravamen" />
           
          </div> <br/>
            </div>
          </div>
        </div>
      </div>


      <div className="segment-container">
        <div className="title-segment-content-solidario" >
          <span className="title-general-segment">
            Te ofrecemos grandes beneficios
          </span>
        </div>
        <div className="body-segment-content-solidario">
          <Row style={{width:"100%"}}>
            <Col md={{ span: 3
             }}>
              <SurgirItemCard
                text={`Pagas mucho menos que un crédito convencional

                `}
                title={"Sin Intereses"}
                width={95}
                image={<img alt='' src={Clock} />}
              />
            </Col>
            <Col md={{ span: 3 }}>
              <SurgirItemCard
                text={`Tienes la solidez y respaldo del grupo Santander`}
                width={95}
                title={"Confiable"}
                image={<img alt='' src={TwoHands} />}
              />
            </Col>
            <Col md={{ span: 3 }}>
              <SurgirItemCard
                text={`No afecta tu capacidad crediticia ante los bancos`}
                width={95}
                title={"Calificación Crediticia"}
                image={<img alt='' src={HandMoney} />}
              />
            </Col>
            <Col md={{ span: 3 }}>
              <SurgirItemCard
                text={`Los fondos están supervisados por la SMV`}
                width={90}
                title={"Seguridad"}
                image={<img alt='' src={Porki} />}
              />
            </Col>
          </Row>
        </div>
      </div>
      <br /><br /><br />

      <div className='home-boxi-auto' style={{ backgroundColor: ' #F6FAFC ' }}>

        <center>
        <img className="home-image-promociones" src={PromocionesHome} alt="Auto nuevo Banner Home" />
          <div className="home-text-promociones">
            <SurgirPrincipalTitle
              text={"¡Haz realidad tu sueño de adquirir un auto nuevo! "}
              subtext={"Con el apoyo de un fondo colectivo es más fácil de lo que crees"}
            ></SurgirPrincipalTitle>
          </div>

          <div>
            <SurgirButton
              onClick={redirectContactanos}
              radius={'32px'}
              fontFamily={"SantanderTextW05-Bold"}
              width='180px'
              height='40px'
              marginTop="20px"
              variant="danger"
            >
              Quiero mi auto
            </SurgirButton>
          </div>

          <a
            className="home-link-rojo"
            style={{
              fontFamily: "SantanderTextW05-Regular",
              color: "#EC0000",
            }}

            href="/auto-nuevo"
          >
            ¡Más información!
          </a>
        </center>

      </div>

    </div>
  );
};

export default Home;